(function () {
	"use strict";

	var filterRoot = document.querySelector(".stories-filter");
	if (!filterRoot) {
		return;
	}

	var cells = document.querySelectorAll(".stories-grid__cell");
	var emptyEl = document.querySelector(".stories-archive__empty");
	var groups = filterRoot.querySelectorAll("[data-filter-group]");

	function activeSlug(group) {
		var active = group.querySelector(".stories-filter__pill.is-active");
		return active ? active.getAttribute("data-filter") : "all";
	}

	function cellMatches(cell, groupName, slug) {
		if (!slug || slug === "all") {
			return true;
		}
		var list = (cell.getAttribute("data-" + groupName) || "").split(/\s+/);
		return list.indexOf(slug) !== -1;
	}

	function setGroup(group, slug) {
		var pills = group.querySelectorAll(".stories-filter__pill");
		pills.forEach(function (pill) {
			var on = pill.getAttribute("data-filter") === slug;
			pill.classList.toggle("is-active", on);
			pill.setAttribute("aria-pressed", on ? "true" : "false");
		});
	}

	function apply() {
		var outcome = "all";
		var service = "all";

		groups.forEach(function (group) {
			var name = group.getAttribute("data-filter-group");
			var slug = activeSlug(group);
			if (name === "outcome") {
				outcome = slug;
			}
			if (name === "service") {
				service = slug;
			}
		});

		var visible = 0;
		cells.forEach(function (cell) {
			var show =
				cellMatches(cell, "outcome", outcome) &&
				cellMatches(cell, "service", service);
			if (show) {
				cell.removeAttribute("hidden");
				visible += 1;
			} else {
				cell.setAttribute("hidden", "");
			}
		});

		if (emptyEl) {
			if (visible === 0) {
				emptyEl.removeAttribute("hidden");
			} else {
				emptyEl.setAttribute("hidden", "");
			}
		}

		var url = new URL(window.location.href);
		if (outcome === "all") {
			url.searchParams.delete("outcome");
		} else {
			url.searchParams.set("outcome", outcome);
		}
		if (service === "all") {
			url.searchParams.delete("service");
		} else {
			url.searchParams.set("service", service);
		}
		window.history.replaceState({}, "", url.pathname + url.search + url.hash);
	}

	function applyFromUrl() {
		var params = new URLSearchParams(window.location.search);
		groups.forEach(function (group) {
			var name = group.getAttribute("data-filter-group");
			var wanted = params.get(name);
			if (!wanted) {
				return;
			}
			var pill = group.querySelector(
				'.stories-filter__pill[data-filter="' + wanted + '"]'
			);
			if (pill) {
				setGroup(group, wanted);
			}
		});
	}

	filterRoot.addEventListener("click", function (event) {
		var pill = event.target.closest(".stories-filter__pill");
		if (!pill || !filterRoot.contains(pill)) {
			return;
		}
		var group = pill.closest("[data-filter-group]");
		if (!group) {
			return;
		}
		setGroup(group, pill.getAttribute("data-filter"));
		apply();
	});

	var reset = document.querySelector(".stories-archive__empty-reset");
	if (reset) {
		reset.addEventListener("click", function () {
			groups.forEach(function (group) {
				setGroup(group, "all");
			});
			apply();
		});
	}

	applyFromUrl();
	apply();
})();
